
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronLeftIcon } from '@radix-ui/react-icons';
import { CaregiverSidebar } from '@/components/CaregiverSidebar';
import { LibraryView } from '@/components/library/LibraryView';
import { SidebarProvider } from '@/components/ui/sidebar';
import { useAuth } from '@/hooks/use-auth';
import { useChildStore } from '@/lib/store/child';
import { Database } from '@/types/supabase';
import { useTheme } from '@/lib/theme/ThemeContext';
import { cn } from '@/lib/utils';

// Define type for Book from Supabase schema
type Book = Database['public']['Tables']['books']['Row'];

export function SleepBookShelf() {
  const navigate = useNavigate();
  const { user, role } = useAuth();
  const isLightTheme = false;
  
  // Access the global child store if user is a caregiver
  const { selectedChild } = useChildStore();

  const handleBackNavigation = () => {
    // Navigate based on user role
    if (role === 'specialist') {
      navigate('/coach-dashboard');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <SidebarProvider>
      <div className={cn(
        "flex h-screen",
        isLightTheme ? "bg-white text-slate-900" : "bg-slate-900 text-white"
      )}>
        {role !== 'specialist' && <CaregiverSidebar />}
        <div className="flex-1 overflow-auto">
          <div className="w-full h-full px-4 sm:px-6">
            <div className="py-4 flex items-center">
              <Button 
                variant="ghost" 
                className={cn(
                  isLightTheme 
                    ? "text-slate-700 hover:text-slate-900 hover:bg-slate-100" 
                    : "text-slate-300 hover:text-white hover:bg-slate-800"
                )}
                onClick={handleBackNavigation}
              >
                <ChevronLeftIcon className="mr-2 h-4 w-4" />
                Back to {role === 'specialist' ? 'Coach Dashboard' : 'Dashboard'}
              </Button>
            </div>
            
            <LibraryView />
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
}
